<template>
  <div class="paper-rejoin-filter-set" v-loading="loading" element-loading-text="加载中，请稍等...">
    <div class="cont">
      <!-- 左侧教学点列表 -->
      <div class="site-list">
        <div class="header">
          <el-button size="mini"
                     :type="currentSiteId === null ? 'primary' : 'default'"
                     @click="handleSelectDefault">
            默认配置
          </el-button>
        </div>
        <div class="search">
          <el-input v-model="searchKeyword"
                    size="mini"
                    placeholder="搜索教学点"
                    prefix-icon="el-icon-search"
                    clearable>
          </el-input>
        </div>
        <div class="list">
          <AppScrollbar style="height: 100%">
            <div class="site-item"
                 v-for="site in filteredSites"
                 :key="site.id"
                 :class="{'is-active': currentSiteId === site.id}"
                 @click="handleSelectSite(site)">
              <span class="name">{{ site.name }}</span>
              <span class="status" :class="{'is-set': site.hasSet}">
                {{ site.hasSet ? '已设置' : '未设置' }}
              </span>
            </div>
          </AppScrollbar>
        </div>
      </div>
      <!-- 右侧筛选条件设置 -->
      <div class="filter-form">
        <div class="form-header">
          <span class="title">{{ currentSiteId === null ? '默认配置' : currentSiteName }}</span>
          <span class="tip" v-if="currentSiteId !== null && !hasSiteSetting">（使用默认配置）</span>
        </div>
        <div class="form-body">
          <AppScrollbar style="height: 100%">
            <el-form ref="form" :model="form" label-width="180px" label-suffix="：" size="mini">
              <el-form-item label="最低学分要求（≥）">
                <el-input-number v-model="form.minCredit" :min="0" :precision="2" :step="1"></el-input-number>
              </el-form-item>
              <el-form-item label="统考情况">
                <el-radio-group v-model="form.uniformExamStatus">
                  <el-radio label="0">不限</el-radio>
                  <el-radio label="1">通过</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="开题报告情况">
                <el-radio-group v-model="form.syllabusStatus">
                  <el-radio label="0">不限</el-radio>
                  <el-radio label="1">通过</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="中期考核情况">
                <el-radio-group v-model="form.midCheckStatus">
                  <el-radio label="0">不限</el-radio>
                  <el-radio label="1">通过</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="预答辩情况">
                <el-radio-group v-model="form.preRejoinStatus">
                  <el-radio label="0">不限</el-radio>
                  <el-radio label="1">通过</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="学术委员会主席审阅论文情况">
                <el-radio-group v-model="form.appraiseStatus">
                  <el-radio label="0">不限</el-radio>
                  <el-radio label="1">通过</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </AppScrollbar>
        </div>
        <div class="form-footer">
          <el-button v-if="currentSiteId !== null && hasSiteSetting"
                     size="mini"
                     @click="handleResetToDefault">
            恢复默认配置
          </el-button>
          <el-button type="primary" size="mini" :loading="committing" @click="handleSave">
            {{ committing ? '保存中...' : '保存设置' }}
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../elements/AppScrollbar'
export default {
  name: 'PaperRejoinFilterSet',
  components: {
    AppScrollbar
  },
  data () {
    return {
      loading: false,
      committing: false,
      searchKeyword: '',
      sites: [],
      currentSiteId: null,
      currentSiteName: '',
      hasSiteSetting: false,
      form: {
        minCredit: 0,
        uniformExamStatus: '0',
        syllabusStatus: '0',
        midCheckStatus: '0',
        preRejoinStatus: '0',
        appraiseStatus: '0'
      }
    }
  },
  computed: {
    filteredSites () {
      if (!this.searchKeyword) {
        return this.sites
      }
      return this.sites.filter(site =>
        site.name.toLowerCase().includes(this.searchKeyword.toLowerCase())
      )
    }
  },
  methods: {
    loadSites () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/paper/rejoin/filter/querySites',
        method: 'post'
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.sites = response.data.sites || []
        } else {
          this.$message.error(response.data.message || '加载教学点失败')
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    loadSetting (siteId) {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/paper/rejoin/filter/getSetting',
        method: 'post',
        data: this.$qs.stringify({ siteId: siteId || '' })
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          const data = response.data.data || {}
          this.form.minCredit = data.minCredit || 0
          this.form.uniformExamStatus = data.uniformExamStatus || '0'
          this.form.syllabusStatus = data.syllabusStatus || '0'
          this.form.midCheckStatus = data.midCheckStatus || '0'
          this.form.preRejoinStatus = data.preRejoinStatus || '0'
          this.form.appraiseStatus = data.appraiseStatus || '0'
          this.hasSiteSetting = data.hasSiteSetting || false
        } else {
          this.$message.error(response.data.message || '加载设置失败')
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleSelectDefault () {
      this.currentSiteId = null
      this.currentSiteName = ''
      this.loadSetting(null)
    },
    handleSelectSite (site) {
      this.currentSiteId = site.id
      this.currentSiteName = site.name
      this.loadSetting(site.id)
    },
    handleSave () {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/paper/rejoin/filter/saveSetting',
        method: 'post',
        data: this.$qs.stringify({
          siteId: this.currentSiteId || '',
          ...this.form
        })
      }).then(response => {
        if (response.data && response.data.errorCode === 0) {
          this.$message.success(response.data.message || '保存成功')
          if (this.currentSiteId) {
            const site = this.sites.find(s => s.id === this.currentSiteId)
            if (site) {
              this.$set(site, 'hasSet', true)
            }
            this.hasSiteSetting = true
          }
        } else {
          this.$message.error(response.data.message || '保存失败')
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleResetToDefault () {
      this.$confirm('确定要恢复使用默认配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.committing = true
        this.$ajax({
          url: '/workspace/manager/paper/rejoin/filter/deleteSiteSetting',
          method: 'post',
          data: this.$qs.stringify({ siteId: this.currentSiteId })
        }).then(response => {
          if (response.data && response.data.errorCode === 0) {
            this.$message.success(response.data.message || '已恢复默认配置')
            const site = this.sites.find(s => s.id === this.currentSiteId)
            if (site) {
              this.$set(site, 'hasSet', false)
            }
            this.hasSiteSetting = false
            this.loadSetting(null)
          } else {
            this.$message.error(response.data.message || '操作失败')
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.committing = false
        })
      }).catch(() => {})
    }
  },
  mounted () {
    this.loadSites()
    this.loadSetting(null)
  }
}
</script>

<style scoped lang="scss">
.paper-rejoin-filter-set {
  height: 100%;
  background-color: #fff;
  &>.cont {
    height: 100%;
    display: flex;
    .site-list {
      width: 240px;
      flex: none;
      border-right: 1px solid #f3f4f6;
      display: flex;
      flex-direction: column;
      .header {
        padding: 15px;
        border-bottom: 1px solid #f3f4f6;
        .el-button {
          width: 100%;
        }
      }
      .search {
        padding: 10px 15px;
        border-bottom: 1px solid #f3f4f6;
      }
      .list {
        flex: 1;
        height: 0;
        .site-item {
          padding: 12px 15px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          cursor: pointer;
          border-bottom: 1px solid #f9f9fa;
          transition: all 0.2s;
          &:hover {
            background-color: #f5f7fa;
          }
          &.is-active {
            background-color: #ecf5ff;
            .name {
              color: #409eff;
              font-weight: bold;
            }
          }
          .name {
            font-size: 13px;
            color: #303133;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .status {
            font-size: 12px;
            color: #909399;
            flex: none;
            margin-left: 10px;
            &.is-set {
              color: #67c23a;
            }
          }
        }
      }
    }
    .filter-form {
      flex: 1;
      display: flex;
      flex-direction: column;
      .form-header {
        padding: 15px 20px;
        border-bottom: 1px solid #f3f4f6;
        .title {
          font-size: 14px;
          font-weight: bold;
          color: #303133;
        }
        .tip {
          font-size: 12px;
          color: #909399;
          margin-left: 10px;
        }
      }
      .form-body {
        flex: 1;
        height: 0;
        padding: 20px;
        .el-form {
          .el-form-item {
            margin-bottom: 22px;
            .el-form-item__label {
              font-size: 13px;
            }
            .el-input-number {
              width: 150px;
            }
          }
        }
      }
      .form-footer {
        padding: 15px 20px;
        border-top: 1px solid #f3f4f6;
        text-align: center;
        .el-button {
          margin: 0 10px;
        }
      }
    }
  }
}
</style>
